import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgQuestionCircle(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.7318 16.9663L14.7306 16.9737L14.7297 16.9812C14.6989 17.2545 14.6838 17.5504 14.6838 17.8683V18.8354H17.2724V18.1112C17.2724 17.9197 17.2854 17.7467 17.3103 17.5913C17.3481 17.4271 17.4038 17.27 17.4776 17.1193C17.5675 16.9491 17.6852 16.7751 17.8324 16.5971L17.8402 16.5869C17.9863 16.3956 18.1765 16.1914 18.414 15.9746L18.4188 15.9701C18.7319 15.6726 19.0374 15.3589 19.3351 15.029L19.3403 15.0229C19.6427 14.671 19.9086 14.3093 20.1373 13.9376C20.3847 13.5433 20.5788 13.1305 20.7188 12.6995C20.8617 12.2596 20.9322 11.7959 20.9322 11.3102C20.9322 10.6115 20.8171 9.96388 20.582 9.37145C20.3624 8.76491 20.0317 8.23983 19.5896 7.80096C19.1615 7.3455 18.6407 6.99705 18.0323 6.75443C17.4175 6.493 16.7384 6.36523 16 6.36523C15.2616 6.36523 14.5825 6.493 13.9677 6.75443C13.3583 6.99744 12.8306 7.34616 12.3886 7.801C11.9608 8.24002 11.6308 8.76441 11.3968 9.36947L11.3953 9.37357C11.1754 9.96537 11.0678 10.6121 11.0678 11.3102V11.6402H13.7002V11.3102C13.7002 10.6044 13.91 10.0489 14.313 9.61625C14.7061 9.19413 15.2543 8.96837 16 8.96837C16.7457 8.96837 17.2939 9.19413 17.6871 9.61625C18.09 10.0489 18.2998 10.6044 18.2998 11.3102C18.2998 11.7736 18.1618 12.2113 17.8754 12.6297C17.5719 13.0732 17.1223 13.5814 16.5186 14.155C16.1318 14.5178 15.8134 14.8528 15.5671 15.1599L15.5609 15.1682C15.3311 15.4739 15.1434 15.7759 15.0009 16.0743L14.9979 16.0809C14.8692 16.3662 14.7803 16.6615 14.7318 16.9663Z"
      />
      <path
        fill="currentColor"
        d="M16 21.2344C14.785 21.2344 13.8 22.2193 13.8 23.4344C13.8 24.6494 14.785 25.6344 16 25.6344C17.2151 25.6344 18.2 24.6494 18.2 23.4344C18.2 22.2193 17.2151 21.2344 16 21.2344Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0.75 16C0.75 7.57766 7.57766 0.75 16 0.75C24.4223 0.75 31.25 7.57766 31.25 16C31.25 24.4223 24.4223 31.25 16 31.25C7.57766 31.25 0.75 24.4223 0.75 16ZM16 3.25C8.95837 3.25 3.25 8.95837 3.25 16C3.25 23.0416 8.95837 28.75 16 28.75C23.0416 28.75 28.75 23.0416 28.75 16C28.75 8.95837 23.0416 3.25 16 3.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuestionCircle);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
